import { getStringValue } from '../tools/string-tools';

export class UsuarioMessages {
  private constructor() {}

  private static readonly MSJ_USUARIO_NO_TIENE_EMPRESA_ASIGNADA = `
    <ul style="text-align: justify; margin-top: -20px; font-size: 18.5px;">
        <li style="padding-bottom: 5px;">Usted no tiene una :empresa:asignada.</li>
        <li style="padding-bottom: 5px;">Para acceder es necesario contar con al menos una :empresa:asignada.</li>
        <li style="padding-bottom: 5px;">Si necesita tener una :empresa:asignada, por favor, comuníquelo al gerente en turno.</li>
    </ul>
    <div style="text-align: center; margin-top: 10px;">
        <span style="font-size: 16px;">¿Necesita ayuda? Contacte a soporte:</span><br>
        <a href="mailto:soporte@majasportswear.com" style="color: #d32f2f; font-weight: bold; font-size: 18px;">soporte@majasportswear.com</a>
    </div>
    `;
  private static readonly MSJ_USUARIO_NO_TIENE_EMPRESA_SELECCIONADA = ` 
    <div>
    <ul style="text-align: justify; margin-top: -20px; font-size: 18.5px;">
        <li style="padding-bottom: 5px;">Usted no tiene una :empresa:seleccionada.</li>
        <li style="padding-bottom: 5px;">Para acceder es necesario contar con al menos una :empresa:seleccionada.</li>
        <li style="padding-bottom: 5px;">Si necesita tener una empresa seleccionada, por favor, elija una de la lista de empresas asignadas.</li>
    </ul>
    </div>
    <div>
        <span style="padding-bottom: 10px; font-size: 20px;"><strong>!Vuelva intentarlo¡</strong></span>
    </div>
    `;

  private static readonly MSJ_USUARIO_EXCEPCION_GENERAL = ` 
    <div style="text-align: center; width: 100%; align-items: center;">
        <div>
        <ul style="text-align: left; margin-top: -20px; font-size: 18.5px;">
            <li style="padding-bottom: 5px;">Se ha producido un error inesperado.</li>
            <li style="padding-bottom: 5px;">Si el problema continúa, comuniquese con el administrador de la aplicación.</li>
        </ul>
        </div>
        <div>
            <span style="padding-bottom: 10px; font-size: 20px;"><strong>!Vuelva intentarlo¡</strong></span>
        </div>
    </div>
    `;

  public static getMsjUsuarioSinEmpresaAsignada(empresa?: string) {
    const txtEmpresa = this.getEmpresa(empresa);
    return this.MSJ_USUARIO_NO_TIENE_EMPRESA_ASIGNADA.replaceAll(
      ':empresa:',
      txtEmpresa
    );
  }

  public static getMsjUsuarioSinEmpresaSeleccionada(empresa?: string) {
    const txtEmpresa = this.getEmpresa(empresa);
    return this.MSJ_USUARIO_NO_TIENE_EMPRESA_SELECCIONADA.replaceAll(
      ':empresa:',
      txtEmpresa
    );
  }

  public static getMsjUsuarioExcepcionGeneral() {
    return this.MSJ_USUARIO_EXCEPCION_GENERAL;
  }

  private static getEmpresa(empresa?: string) {
    let msj = getStringValue(empresa, '  ');
    if (msj.trim() !== '') {
      msj = ' ' + msj + ' ';
    }
    return msj;
  }
}
